import React, {ReactElement} from 'react';
import {Alignment} from '../../../../types';
import Headers, {HeaderType} from '../../Text/Headers/Headers';
import Paragraph from '../../Text/Paragraph/Paragraph';
import './HowDoesItWorkItem.scss';

export interface HowDoesItWorkContentItem {
  number: number;
  title: string;
  description?: string;
}

// not documented in story book as it is a tightly coupled dependency of HowDoesItWorkPoints
// not tested for the same reason, it is tested in the snapshot of HowDoesItWorkPoints
function HowDoesItWorkItem({number, title, description}: HowDoesItWorkContentItem): ReactElement {
  return (
    <div className="howDoesItWorkItem">
      <span className="howDoesItWorkItem__number">{number}</span>
      <div className="howDoesItWorkItem__content">
        <Headers headerType={HeaderType.H3} className="howDoesItWorkItem__title" alignment={Alignment.LEFT}>
          {title}
        </Headers>
        {description && <Paragraph className="howDoesItWorkItem__description">{description}</Paragraph>}
      </div>
    </div>
  );
}

export default HowDoesItWorkItem;
